export default __webpack_public_path__ + "static/media/instagram.8e408da0.png";